import restaurantService from "@/services/restaurant";

const state = {
  // ...existing code...
  users: [],
  // ...existing code...
};

const mutations = {
  // ...existing code...
  SET_USERS(state, users) {
    state.users = users;
  },
  // ...existing code...
};

const actions = {
  // ...existing code...
  async dispatchUsers({ state, commit, rootState }, { refetch = false } = {}) {
    if (!refetch && state.users && state.users.length > 0) {
      return state.users;
    }
    const restaurantId = rootState.restaurant?.id || state.id;
    const { data } = await restaurantService.getRestaurantUsers(restaurantId);
    const users = (data?.users || []).map((item) => ({
      ...item,
      fullName: `${item.name} ${item.lastname}`,
    }));
    commit("SET_USERS", users);
    return users;
  },
  // ...existing code...
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  // ...existing code...
};